import React from 'react';
import styled from 'styled-components';

import Picture from '../../../../containers/assets/instructor-onboarding-image14.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  flex: 1;
`;

const Container = styled.div`
  padding: 40px;
  width: 80%;
  max-width: 794px;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Text3 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 12px;

  b {
    color: #ed716d;

    &.black-note {
      color: rgba(0, 27, 59, 0.94);
    }
  }
`;

const Image = styled.div`
  display: flex;
  margin-top: 12px;
`;

const HowGradingWorksStep2 = () => (
  <Wrapper>
    <Container>
      <Text1>How Grading Works</Text1>
      <Text2>Team Score</Text2>
      <Text3>
        A student's team score is based on how well that team performs
        over the rounds played. If a team <b>hits all of their financial targets</b> each
        round, they'll receive a team score of 100%. All rounds are weighted equally by default,
        but the round weights can be skewed towards the later rounds. Targets can also be modified.
      </Text3>

      <Image>
        <img src={Picture} alt="" />
      </Image>
    </Container>
  </Wrapper>
);

export default HowGradingWorksStep2;



// WEBPACK FOOTER //
// ./src/instructor/components/onboarding/how-grading-works/step2.js